const SET = 'patron/programMembership/SET';
const UPDATE_STATUS = 'patron/programMembership/UPDATE_STATUS';
const HIDE_PRIVATE_WARNING = 'patron/programMembership/HIDE_PRIVATE_WARNING';

export default {
  SET,
  UPDATE_STATUS,
  HIDE_PRIVATE_WARNING,
};
